@if (isLoading) {
  <app-main-loader-lottie> </app-main-loader-lottie>
} @else {
  <div class="content">
    <div class="search-input-row">
      <pdq-input
        [withIcon]="true"
        placeholder="Search reference no."
        icon="search"
        [autofocus]="true"
        (keyup.enter)="onFreeTextSearch($event.target?.value)">
      </pdq-input>
    </div>
    <pdq-table
      [isServerPagingMode]="true"
      [columnsSettings]="columns"
      [rows]="data"
      [activePage]="activePage"
      [totalPages]="totalPages"
      [perPageActiveOption]="recordsPerPage"
      [sortBy]="sortByProp"
      [sortDirection]="sortDirection"
      (sort)="onSort($event)"
      (changePerPage)="changePerPage($event)"
      (changePage)="paginate($event)"
      (jumpToPage)="jumpToPage($event)"></pdq-table>
  </div>
}
